import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { environment } from '@env';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',

  imports: [RouterModule, ToastModule, ConfirmDialogModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  pageTitle: string = environment.businessInfo.name;

  private readonly title = inject(Title);

  constructor() {
    this.title.setTitle(this.pageTitle);
  }
}
